import { FC } from "react";
import { Button, ButtonProps } from "antd";
import openModal from "../../../../components/modal/openModal";
import LeasingStore from "../../../../contexts/leasingStore";
import _t from "../../../../lang/translate";
import Icon from "../../../../assets/icons/icon";
import PopoverList from "../../../../components/popups/popoverList";

const StartDigitalSigningButton: FC<ButtonProps> = (props) => {
  const { leasingCase } = LeasingStore.useContainer();
  const { contract, id, flags } = leasingCase;
  const contractFiles = contract?.documents;
  const { contractGenerated, readonly } = flags;
  const disabled = !contractGenerated || readonly;

  const handleStartDigitalSigning = async () => {
    try {
      await openModal<{ data: string }>("startDigitalSigning", { contractFiles, id });
    } catch (error) {
    }
  };

  return (
    <PopoverList list={[
      !contractGenerated ? "Kontrakter er ikke genereret endnu" : null,
      readonly ? _t("msg.case_is_readonly") : null,
    ].filter(Boolean) as string[]}>
      <Button {...props} onClick={handleStartDigitalSigning} disabled={disabled} icon={<Icon size="medium" name="mail-outline" />}>
        {_t("send_digital_signature")}
      </Button>
    </PopoverList>
  );
};

export default StartDigitalSigningButton;
